var PersonalMessagingFactory = function ($resource, $window) {
    var pmAPI =
        "/participant-web-services/rest/personalMessaging/isPMEligible/groupId/:groupId/accu/:accu";

    var pmParams = {
        accu: "@accu",
        groupId: "@groupId"
    };

    return {
        isPMEnabled: $resource(__baseApiUrl__ + pmAPI, pmParams, {
            query: {
                method: "GET",
                isArray: false,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        })
    };
};

PersonalMessagingFactory.$inject = ["$resource", "$window"];
export default PersonalMessagingFactory;
